import { EXERCISE_REQUEST_SORTS, EXERCISE_REQUEST_STATUSES } from '@steado/admin-contract/exercise-requests';
import { z } from 'zod';

/**
 * The status, the order, the page and the open request all live in the URL,
 * so "the most wanted open requests" is a link somebody can paste and a
 * request under discussion survives a refresh.
 *
 * Opens on the open queue in reach order rather than on everything, unlike
 * food requests: one row here stands for every scan of a name, so a resolved
 * one is not context for the next the way a person's earlier request is.
 */
export const exerciseRequestsSearchSchema = z.object({
  status: z
    .enum([...EXERCISE_REQUEST_STATUSES, 'all'])
    .optional()
    .catch(undefined),
  sort: z.enum(EXERCISE_REQUEST_SORTS).optional().catch(undefined),
  cursor: z.string().optional().catch(undefined),
  /** The request whose drawer is open. */
  open: z.string().uuid().optional().catch(undefined),
});

export type ExerciseRequestsSearch = z.infer<typeof exerciseRequestsSearchSchema>;
